<template>
  <div class="route-view-card ma-0 pa-15 fill-height d-flex flex-column">
    <span class="titulo"> Preencha as informações </span>
    <v-row>
      <!-- COLUNA DA ESQUERDA -->
      <v-col cols="5">
        <div class="subtitulo"> Informações</div>
        <!-- RESPONSAVEL INFORMACOES        -->
        <span class="label mt-4"> Responsável pelas informações: </span>
        <v-row dense>
          <v-col class="my-0 py-0" cols="6">
            <v-autocomplete color="#BCCCCA" background-color="white" outlined dense cache-items
                            append-icon=""
                            :hide-no-data="loadingResponsavelTecnico || !searchResponsavelTecnico ||
                        searchResponsavelTecnico.length < 3"
                            v-model="boletimSanitario.cdResponsavelTecnico"
                            :loading="loadingResponsavelTecnico ? 'info' : false"
                            :items="listaResponsavelTecnico"
                            :search-input.sync="searchResponsavelTecnico"
                            item-value="idResponsavelTecnico" item-text="nmPessoa"
                            placeholder="Pesquise o responsável pelas informações"
                            hint="Mínimo de 3 caracteres"
                            :rules="[OBRIGATORIO]" />
          </v-col>
          <v-col class="my-0 py-0" cols="6">
            <v-select color="#BCCCCA" background-color="white" dense outlined
                      v-model="boletimSanitario.csResponsavelInformacoes"
                      :items="listaTipoResponsavelInformacoes"
                      item-value="csResponsavelInformacoes" item-text="dsResponsavelInformacoes"
                      :menu-props="{ offsetY: true, bottom: true}" />
          </v-col>
        </v-row>

        <!-- RASTREABILIDADE        -->
        <span class="label mt-4"> Rastreabilidade </span>
        <v-select color="#BCCCCA" background-color="white" dense outlined v-model="boletimSanitario.csRastreabilidade"
                  :items="listaTipoRastreabilidade" placeholder="Selecione o tipo de rastreabilidade"
                  item-value="csRastreabilidade" item-text="dsRastreabilidade"
                  :menu-props="{ offsetY: true, bottom: true}" />

        <!-- MUNICIPIO        -->
        <span class="label mt-4"> Cidade </span>
        <v-autocomplete color="#BCCCCA" background-color="white" outlined dense cache-items
                        append-icon=""
                        :hide-no-data="loadingMunicipio || !searchMunicipio || searchMunicipio.length < 3"
                        :rules="[OBRIGATORIO]"
                        v-model="boletimSanitario.cdMunicipioEmissao"
                        :loading="loadingMunicipio ? 'info' : false"
                        :items="listaMunicipio"
                        :search-input.sync="searchMunicipio"
                        item-value="idMunicipio" item-text="nmMunicipio"
                        hint="Mínimo de 3 caracteres"
                        placeholder="Pesquise a cidade" />
        
        <v-row dense>
          <v-col class="my-0 py-0" cols="6">
            <span class="label mt-4"> Data de emissão </span>
            <Datepicker v-model="boletimSanitario.dtEmissao"
                            dense outlined background-color="white"
                            placeholder="Selecione a data de emissão"
            />
          </v-col>
          <v-col class="my-0 py-0" cols="6">
            <span class="label mt-4"> Hora de emissão </span>
            <menu-timepicker v-model="boletimSanitario.hrEmissao"
                            dense outlined background-color="white"
                            placeholder="Selecione a hora de emissão"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col class="my-0 py-0" cols="6">
            <span class="label mt-4"> Data da retirada da alimentação da granja </span>
            <Datepicker v-model="boletimSanitario.dtRetiradaRacao"
                            dense outlined background-color="white"
                            placeholder="Selecione a data da retirada de ração"
            />
          </v-col>
          <v-col class="my-0 py-0" cols="6">
            <span class="label mt-4"> Hora da retirada da alimentação da granja </span>
            <menu-timepicker v-model="boletimSanitario.hrRetiradaRacao"
                            dense outlined background-color="white"
                            placeholder="Selecione a hora da retirada de ração"
            />
          </v-col>
        </v-row>

      </v-col>
      <!-- COLUNA DA DIREITA -->
      <v-col cols="7">
        <div>
          <span class="subtitulo"> GTAs desse Boletim </span>
        </div>
        <v-row class="py-0 shrink">
          <v-col>
            <span class="label"> Data de saída </span>
            <menu-datepicker v-model="filtrosGTA.dtSaidaGta" dense outlined background-color="white"
                             placeholder="Filtre as datas de saída de animais" disabled
                             @change="loadListaSaidaAnimais" />
          </v-col>
          <v-col>
            <span class="label"> Planta de destino </span>
            <v-autocomplete color="#BCCCCA" background-color="white" outlined dense cache-items hide-no-data
                            v-model="filtrosGTA.idPLantaAbate" :loading="loadingPlantaAbate"
                            :items="listaPlantaAbate"
                            item-value="idPlantaAbate" item-text="nmPlantaAbate"
                            placeholder="Selecione a planta de abate"
                            @input="loadListaSaidaAnimais" />
          </v-col>
        </v-row>
        <v-row class="pa-3 rounded-b-lg">
          <!-- TABELA SAIDAS GTA -->
          <v-data-table hide-default-footer show-select v-model="boletimSanitario.saidaAnimais"
                        :headers.sync="headers" :items="listaSaidaAnimais"
                        :loading="loadingSaidaAnimais ? 'info' : false"
                        item-key="cdSaidaAnimais" class="full-width elevation-2"
                        no-data-text="Não foram encontradas saída de animais com esses filtros"
          >
            <template v-slot:body="{ items, isSelected, select }">
              <draggable v-model="listaSaidaAnimais" tag="tbody" @update="reordenarTabela">
                <tr v-for="item in items" :key="'trow__'+item.cdSaidaAnimais">
                  <td> {{ item.nrCarga }}</td>
                  <td>
                    <v-simple-checkbox color="#0090E9" :value="isSelected(item)"
                                       @click="selecionarSaida(item, select, isSelected(item))" />
                  </td>
                  <td>{{ item.dtSaida | dateFormat("DD/MM/Y") }}</td>
                  <td>{{ item.nrGta }}-{{ item.dsSerieGta }}</td>
                  <td>{{ item.qtAnimais }}</td>
                  <td class="d-flex flex-row align-center justify-space-between">
                    {{ item.nmPlantaAbate }}
                    <v-icon style="cursor: grab;">mdi-drag</v-icon>
                  </td>
                </tr>
              </draggable>
            </template>

            <!-- SELECT -->
            <template v-slot:header.data-table-select="{ on, props }">
              <v-simple-checkbox color="#0090E9" v-model="props.value"
                                 :indeterminate="props.indeterminate"
                                 @input="selecionarTodos(on.input, $event)" />
            </template>
          </v-data-table>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MenuDatepicker from "./MenuDatepicker";
import MenuTimepicker from "./MenuTimepicker";
import Datepicker from "./Datepicker";
import {MODELS, RULES} from "../resources";
import moment from "moment";
import {validationMixin} from "vuelidate";
import required from "vuelidate/lib/validators/required";
import draggable from "vuedraggable";
import Programacao from '../../programacaoAbate/components/Programacao.vue';

export default {
  name: "DadosBoletimSanitario",
  components: {draggable, MenuDatepicker, Datepicker, MenuTimepicker, Programacao,},
  mixins: [validationMixin],
  validations() {
    if (this.step !== 1) return { boletimSanitario: {}}
    if (this.loadingRegistrosRelacionados) return { boletimSanitario: () => false }

    return {
      boletimSanitario: {
        cdResponsavelTecnico: {required},
        csResponsavelInformacoes: {required},
        cdMunicipioEmissao: {required},
        dtEmissao: {required},
        hrEmissao: {required},
        dtRetiradaRacao: {
          required: required,
          saidaMaiorQueDtRetiradaRacao: this.DTSAIDAMAIORQUERETIRADARACAO(this.ultimaDtSaida),
        },
        hrRetiradaRacao: {required},
        saidaAnimais: {required},
      },
    };
  },
  props: {
    step: Number,
    btnContinuar: Boolean,
    boletimSanitario: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    //RESPONSAVEL TECNICO
    listaResponsavelTecnico: [],
    loadingResponsavelTecnico: false,
    searchResponsavelTecnico: '',
    //TIPO RESPONSAVEL INFORMAÇÃO
    listaTipoResponsavelInformacoes: MODELS.TIPO_RESPONSAVEL_INFORMACOES,
    //TIPO RASTREABILIDADE
    listaTipoRastreabilidade: MODELS.TIPO_RASTREABILIDADE,
    //MUNICIPIOS
    listaMunicipio: [],
    loadingMunicipio: false,
    searchMunicipio: '',
    //GTAs
    filtrosGTA: {
      dtSaidaGta: null,
      idPLantaAbate: null
    },
    //PLANTA DE ABATE
    listaPlantaAbate: [],
    loadingPlantaAbate: false,

    //SAIDAS
    headers: MODELS.HEADERS_SAIDA_ANIMAIS,
    listaSaidaAnimais: [],
    loadingSaidaAnimais: false,
    totalCargas: 0,
  }),
  computed: {
    ultimaDtSaida() {
      if (!this.boletimSanitario.saidaAnimais || this.boletimSanitario.saidaAnimais.length === 0) return null
      if (!this.listaSaidaAnimais || this.listaSaidaAnimais.length === 0) return null
      const listaDtSaidaAnimais = this.boletimSanitario.saidaAnimais.map(saida => {
        const saidaAnimais = this.listaSaidaAnimais.find(saidaAnimais => saidaAnimais.cdSaidaAnimais === saida.cdSaidaAnimais)
        const dtSaida = moment(saidaAnimais.dtSaida, 'YYYY-MM-DD')

        if (!dtSaida.isValid()) return null
        return dtSaida
      })

      const maxDtSaida = moment.max(listaDtSaidaAnimais).format('YYYY-MM-DD')

      return listaDtSaidaAnimais ? maxDtSaida : null
    },
    errorsDtRetiradaRacao(){
      if (!this.ultimaDtSaida ||
          !this.boletimSanitario.dtRetiradaRacao ||
          !this.$v.boletimSanitario ||
          !this.$v.boletimSanitario.dtRetiradaRacao) return []

      return this.$v.boletimSanitario.dtRetiradaRacao.saidaMaiorQueDtRetiradaRacao ?
          [] :
          ['Data de retirada da ração não pode ser depois da última saída selecionada']
    },
    loadingRegistrosRelacionados() {
      return this.loadingMunicipio && this.loadingResponsavelTecnico
    }
  },
  methods: {
    ...RULES,
    async selecionarSaida(item, select, isSelected) {
      await select(item, !isSelected)
      this.reordenarTabela()
    },
    async selecionarTodos(selectAll, evento) {
      await selectAll(evento)
      this.reordenarTabela()
    },
    reordenarTabela(evt) {
      let nrCargaAtual = this.totalCargas + 1
      this.listaSaidaAnimais = this.listaSaidaAnimais.map(saida => {
        const selecionado = this.boletimSanitario.saidaAnimais.findIndex(saidaSel =>
            saida.cdSaidaAnimais === saidaSel.cdSaidaAnimais
        )

        if (selecionado > -1) {
          const nrCarga = _.assign(saida, {nrCarga: nrCargaAtual})
          nrCargaAtual++
          return nrCarga
        } else {
          return _.assign(saida, {nrCarga: ''})
        }
      })
    },
    loadListaPlantaAbate() {
      this.loadingPlantaAbate = true
      this.$axios.get('planta-abate/')
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            this.listaPlantaAbate = res.data[0].data
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loadingPlantaAbate = false
          })
          .finally(() => {
            this.loadingPlantaAbate = false
          })
    },
    loadListaSaidaAnimais() {
      this.loadingSaidaAnimais = true

      let query = {}
      query['cdLoteProducao'] = this.boletimSanitario.cdLoteProducao > 0 ?
          this.boletimSanitario.cdLoteProducao :
          this.$route.query.lp

      if (this.filtrosGTA.dtSaidaGta && moment(this.filtrosGTA.dtSaidaGta).isValid())
        query['dtSaidaAnimais'] = this.filtrosGTA.dtSaidaGta
      if (this.filtrosGTA.idPLantaAbate && this.filtrosGTA.idPLantaAbate > 0)
        query['cdPlantaABate'] = this.filtrosGTA.idPLantaAbate
      if (this.$route.params.idBoletimSanitario && this.$route.params.idBoletimSanitario > 0)
        query['idBoletimSanitario'] = this.$route.params.idBoletimSanitario

      this.$axios.get('boletim-sanitario/saidas_animais_search/', {params: query})
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) {
              this.listaSaidaAnimais = []
              return
            }
            const totalCargas = res.data[0].data['totalCargas']
            const saidas = res.data[0].data['saidasDisponiveis'].map(
                (saida, idx) => _.extend(saida, {nrCarga: idx + 1 + totalCargas})
            )

            this.listaSaidaAnimais = saidas
            this.totalCargas = totalCargas
            if(!this.boletimSanitario.idBoletimSanitario && this.boletimSanitario.idBoletimSanitario > 0)
              this.boletimSanitario.saidaAnimais = saidas
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loadingSaidaAnimais = false
          })
          .finally(() => this.loadingSaidaAnimais = false)
    },
    loadRegistrosRelacionados() {
      this.loadResponsavelTecnico()
      this.loadMunicipio()
    },
    loadResponsavelTecnico: _.debounce(function (val) {
      this.loadingResponsavelTecnico = true

      let query = new URLSearchParams()
      let cfNmPessoa = {
        "field": "nmPessoa", "op": "ilike", "value": `%${val}%`
      }
      if (val)
        query.append("cf", JSON.stringify(cfNmPessoa))
      else
        query.append("idResponsavelTecnico", this.boletimSanitario.cdResponsavelTecnico)

      this.$axios.get('responsavel-tecnico/', {params: query})
          .then((response) => {
            if (!response.data) return
            if (!response.data[0].data) return

            this.listaResponsavelTecnico = response.data[0].data
          })
          .catch(error => {
            this.$store.commit('setSnack', {type: 'error', msg: error})
            this.loadingResponsavelTecnico = false
          })
          .finally(() => {
            this.loadingResponsavelTecnico = false
          })
    }, 1000),
    loadMunicipio: _.debounce(function (val) {
      this.loadingMunicipio = true

      let query = ''
      if (val) query = '?nmMunicipio=' + val
      else query = this.boletimSanitario.cdMunicipioEmissao

      this.$axios.get(process.env.VUE_APP_URL_API_ESTABELECIMENTO + 'municipio/' + query)
          .then((response) => {
            if (!response.data) return

            this.listaMunicipio = !val ?
                [response.data] :
                response.data
          })
          .catch(error => {
            this.$store.commit('setSnack', {type: 'error', msg: error})
            this.loadingMunicipio = false
          })
          .finally(() => {
            this.loadingMunicipio = false
          })
    }, 1000),
  },
  watch: {
    '$v.$invalid'(value) {
      this.$emit('update:btnContinuar', !value)
    },
    searchResponsavelTecnico(newVal, oldVal) {
      if (!newVal || newVal === oldVal || newVal === '' || newVal.length < 3) return
      if (this.boletimSanitario.cdResponsavelTecnico &&
          this.boletimSanitario.cdResponsavelTecnico > 0 &&
          this.listaResponsavelTecnico.find(rt =>
              rt.idResponsavelTecnico === this.boletimSanitario.cdResponsavelTecnico)['nmPessoa'] === newVal) {
        return
      }

      this.loadingResponsavelTecnico = true
      this.loadResponsavelTecnico(newVal)
    },
    searchMunicipio(newVal, oldVal) {
      if (!newVal || newVal === oldVal || newVal === '' || newVal.length < 3) return

      if (this.boletimSanitario.cdMunicipioEmissao &&
          this.boletimSanitario.cdMunicipioEmissao > 0 &&
          this.listaMunicipio.find(rt => rt.idMunicipio === this.boletimSanitario.cdMunicipioEmissao)['nmMunicipio']
          === newVal) {
        return
      }
      this.loadingMunicipio = true
      this.loadMunicipio(newVal)
    },
  },
  mounted() { 
    if (this.boletimSanitario.idBoletimSanitario) this.loadRegistrosRelacionados()

    this.loadListaSaidaAnimais()
    this.loadListaPlantaAbate()
  },
}
</script>

<style scoped lang="scss">
.route-view-card {
  background-color: #F2F5F3;
}

.titulo {
  font-family: Roboto;
  font-size: 32px;
  color: #35565B;
  opacity: 0.8;
}

.subtitulo {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7B9596;
}
</style>